import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import '@vuepic/vue-datepicker/dist/main.css';
import DatePicker from '@vuepic/vue-datepicker';

export default /*#__PURE__*/_defineComponent({
  __name: 'DatePicker',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DatePicker), { class: "date-picker-flex" }))
}
}

})